import React from "react";
import "./BodySite.css"
import "./chatSites.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";


function load() {
    var jsScript = document.createElement('script');
    jsScript.type = "text/javascript";
    jsScript.src = '//go.botmaker.com/rest/webchat/p/SY06ETGARK/init.js';
    document.getElementById("chatMiMuniScope").appendChild(jsScript);
}
const EPagosSites = () => {

    return (
    <>
    
    <iframe src='./epagos.html' frameborder="0" class="epagosClip"></iframe>
 
 </>
 );
    
    }
export default EPagosSites;